/**
 * @config cdnUrl OSS服务地址
 * @config appUrl API服务器地址
 * @config debug 全局调试
 *
 */
export default {
  cdnurl: 'https://yxzshop.oss-cn-beijing.aliyuncs.com',
  // appurl: 'https://api.yixiaozhi.com', //测试版
  appurl: 'https://www.yixiaozhi.com', //正式版
  versionName: '2.0',
  versionCode: '20',
  debug: false

}



//////////////////
// WEBPACK FOOTER
// ./common/config/config.js
// module id = 122
// module chunks = 0